export var ImportStatus;
(function (ImportStatus) {
    ImportStatus["Created"] = "Created";
    ImportStatus["Processing"] = "Processing";
    ImportStatus["Failed"] = "Failed";
    ImportStatus["Succeeded"] = "Succeeded";
})(ImportStatus || (ImportStatus = {}));
